import React, { useState } from "react";
import "./SideMenu.scss";
import { LogoImg, LogoImg2 } from "assets/images";
import { NavLink } from "react-router-dom";
import {
  FaCog,
  FaEdit,
  FaExchangeAlt,
  FaHashtag,
  FaListUl,
  FaMicrosoft,
  FaPaperPlane,
  FaUserAlt,
} from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import {
  bellIcon,
  brandIcon,
  categoryIcon,
  contentMIcon,
  dashboardIcon,
  faqIcon,
  hashtagIcon,
  onBoardingIcon,
  orderMIcon,
  postIcon,
  userIcon,
} from "assets/icons";
const SideMenu = () => {
  const [isBrandExpanded, setIsBrandExpanded] = useState(false);
  const [isProductExpanded, setIsProductExpanded] = useState(false);

  return (
    <>
      <aside className="aside">
        <div className="logo">
          <img src={LogoImg} alt="Organization name" />
        </div>
        <div className="side_menu">
          <ul>
            <li>
              <NavLink to="/dashboard">
                <img src={dashboardIcon} alt="" />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/user-management">
                <img src={userIcon} alt="" />
                <span>User management</span>
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/brand-management">
                <span>Brand management</span>
                <FaCodeBranch />
              </NavLink>
            </li> */}
            <li>
              <NavLink to="/brand-management/onboarding">
                <FaPaperPlane />
                <span>Onboarding Brand Management</span>
              </NavLink>
            </li>
            {/* <li
              className={isBrandExpanded ? "active" : ""}
              style={{ cursor: "pointer" }}
            >
              <button
                type="button"
                className="nav-item"
                onClick={() => setIsBrandExpanded(!isBrandExpanded)}
              >
                 <img src={categoryIcon} alt="" />
                <span>Category management</span>
                <IoIosArrowForward className="arrow_button" />
              </button>
                 {isBrandExpanded && (
                <ul className="nested-menu">
                  <li>
                    <NavLink to="web-category-management">
                      <span>Wardrobe Category </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/product-category-management">
                      <span>Product Category  </span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li> */}
            {/* <li>
              <NavLink to="/category-management">
              <img src={categoryIcon} alt="" />
                <span>Wardrobe Category Management</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink to="web-category-management">
                <img src={categoryIcon} alt="" />
                <span>Wardrobe Category Management</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/post-management">
                <img src={postIcon} alt="" />
                <span>Post management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/onboarding-questions">
                <img src={onBoardingIcon} alt="" />
                <span>Onboarding Questions</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/blog-management">
                <img src={postIcon} alt="" />
                <span>Blog management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/event-management">
                <img src={postIcon} alt="" />
                <span>Event management</span>
              </NavLink>
            </li>
            <li
              className={isProductExpanded ? "active" : ""}
              style={{ cursor: "pointer" }}
            >
              <button
                type="button"
                className="nav-item"
                onClick={() => setIsProductExpanded(!isProductExpanded)}
              >
                <img src={brandIcon} alt="" />
                <span>Product management</span>
                <IoIosArrowForward className="arrow_button" />
              </button>
              {isProductExpanded && (
                <ul className="nested-menu">
                  <li>
                    <NavLink to="/product-management/exclusive">
                      {/* <FaPaperPlane /> */}
                      <span>Exclusive products</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/product-management/scrape">
                      {/* <FaBriefcase /> */}
                      <span>Web scraped products</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <NavLink to="/order-management">
                <img src={orderMIcon} alt="" />
                <span>Order management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/payment-management">
                <img src={postIcon} alt="" />
                <span>Payment management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/report-management">
                <img src={postIcon} alt="" />
                <span>Report management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/plan-management">
                <img src={postIcon} alt="" />
                <span>Plan management</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/content-management">
                <img src={contentMIcon} alt="" />
                <span>Content management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/faq-management">
                <img src={faqIcon} alt="" />
                <span>FAQ Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/notification-management">
                <img src={bellIcon} alt="" />
                <span>Notification Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/hastag-management">
                <img src={hashtagIcon} alt="" />
                <span>Hashtag management</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/support-management">
                <img src={faqIcon} alt="" />
                <span>Help & Support Management</span>
              </NavLink>
            </li>

            {/* <li>
              <NavLink to="/referral-management">
                <img src={postIcon} alt="" />
                <span>Referral Management</span>
              </NavLink>
            </li> */}
            {/*
            <li>
              <NavLink to="/banner-management">
                <span>Banner management</span>
                <FaImage />

              </NavLink>
            </li>
            <li>
              <NavLink to="/donation">
                <span>Donation</span>
                <FaHandHoldingHeart />
              </NavLink>
            </li>

       
            <li>
              <NavLink to="/vacancy-management">
                <span>Vacancy management</span>
                <FaHospitalUser />
              </NavLink>
            </li>
            <li>
              <NavLink to="/notification-management">
                <span>NotificationIcon management</span>
                <FaBell />
              </NavLink>
            </li> */}
          </ul>
        </div>
      </aside>
    </>
  );
};

export default SideMenu;
